import { Color, Engine } from 'excalibur';
import { Brick } from './brick';
import { bricks } from './bricks';

export const generateBricks = (engine: Engine) => {
    const padding = 20;
    const xoffset = 230;
    const yoffset = 20;
    const columns = 8;
    const rows = 5;

    const brickColor = [Color.Violet, Color.Orange, Color.Yellow];
    const brickWidth = engine.drawWidth / columns - padding - padding / columns; // px
    const brickHeight = 40;
    bricks.length = 0;
    for (let j = 0; j < rows; j++) {
        for (let i = 0; i < columns; i++) {
            const brick = new Brick({
                x: xoffset + i * (brickWidth + padding) + padding,
                y: yoffset + j * (brickHeight + padding) + padding,
                width: brickWidth,
                height: brickHeight,
                color: brickColor[j % brickColor.length],
            });
            bricks.push(brick);
            engine.add(brick);
        }
    }
};
